module.exports = __webpack_public_path__ + "ae6b7a5c1a988619f2a40faad003d0f2.jpg";